import { render, staticRenderFns } from "./TabSelector.vue?vue&type=template&id=3c37d9ba&scoped=true&"
import script from "./TabSelector.vue?vue&type=script&lang=js&"
export * from "./TabSelector.vue?vue&type=script&lang=js&"
import style0 from "./TabSelector.vue?vue&type=style&index=0&id=3c37d9ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c37d9ba",
  null
  
)

export default component.exports